<app-auth-navbar></app-auth-navbar>
<div class="section-4 mt-5">
    <div class="container-8 w-container">
      <div class="div-block-20">
        <h1 class="about-heading">Making money <br>meaningful</h1>
      </div>
      <div class="div-block-19">
        <div class="text-block-13">For people living between countries.</div>
      </div>
    </div>
  </div>
  <div class="section-5">
    <div class="container-7 w-container">
      <div class="div-block-21">
        <h1 class="heading-3">Our mission</h1>
      </div>
      <p class="paragraph-about">Almost everyone is from somewhere else one way or another. We all have ties to different places, leaving footprints of love and assets of affection. No matter where we go, those relationships are never lost but todays’ money transfer services certainly don’t make it easy to stay connected.</p>
      <p class="paragraph-about">While there is a lot of choice for sending funds, using the service is not always easy and for some currencies the fees are unnecessarily high. And if you want to do more than sending money like sending favours, gifts, and gestures instead, there aren’t many ways to do that.</p>
      <p class="paragraph-about">We understand that life because we live it every day. That’s why we’re changing the way money transfers work, creating a better experience for everyone around the world. <br><br>Sending money across borders shouldn’t cost a fortune, so we keep fees to a competitive minimum for all currencies. And if you want to do something even more meaningful, like paying for someone’s bills or daily necessities, you can do that right from our platform.</p>
      <p class="paragraph-about">As a high technology player with strategic partnerships, we make money transfers meaningful for people living in between countries, so they can save more and do more.</p>
    </div>
  </div>
  <div class="benefits-heading-section">
    <div class="w-container">
      <div class="testimonial-header"><img src="assets/images/Logo-pink.svg" loading="lazy" alt="n2xpress - Send money across borders, the easy way." class="benefits-chop">
        <div class="benefits-heading">Security</div>
      </div>
    </div>
  </div>
  <div class="benefits-section">
    <div class="w-container">
      <div class="security-upper">
        <div class="security-box">
          <div class="benefit-header">
            <div class="fully-regulated">Fully regulated</div>
          </div>
          <div class="benefit-body">
            <div class="benefit-body-text">N2Xpress is a trademark name for Alpha Fortress Ltd. . We are licensed and regulated by the Financial Transactions and Reporting Analysis Centre of Canada (FINTRAC).</div>
          </div>
        </div>
        <div class="security-box">
          <div class="benefit-header">
            <div class="comliance-and-encryption">Compliance &amp; encryption</div>
          </div>
          <div class="benefit-body">
            <div class="benefit-body-text">We have state of the art compliance and encryption features designed to prevent transactions that may be associated with Anti-Money Laundering (AML) and Anti-Terrorist Financing (ATF) activities. All transactions meet Know Your Customer (KYC) guidelines.</div>
          </div>
        </div>
      </div>
      <div class="security-lower">
        <div class="security-box">
          <div class="benefit-header">
            <div class="world-class-security">World class security</div>
          </div>
          <div class="benefit-body">
            <div class="benefit-body-text">We automate compliance checks and balances to be compliant with regulatory guidelines, policies, and procedures of regulators in the UK, Canada, and around the world.<br></div>
          </div>
        </div>
        <div class="security-box">
          <div class="benefit-header">
            <div class="protecting-your-information">Protecting your information</div>
          </div>
          <div class="benefit-body">
            <div class="benefit-body-text">We are Payment Card Industry (PCI) compliant, following PCI Security Council standards to secure and protect your credit card data at all times. In addition, we keep your personal data private following General Data Protection Regulation (GDPR) compliance standards. <br></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="testimonial-section">
    <div class="w-container">
      <div class="testimonial-header"><img src="assets/images/Testimonial-Chop.svg" loading="lazy" alt="n2xpress - Send money across borders, the easy way." class="image-2">
        <div class="section-header-text testimonial">What our customers say</div>
      </div>
      <div data-delay="4000" data-animation="slide" data-autoplay="1" data-nav-spacing="5" data-duration="500" data-infinite="1" class="w-slider">
        <div class="w-slider-mask">
          <div class="slide w-slide">
            <div class="slide-content">
              <div class="text-block-2">“N2Xpress made delivery of essentials for my mom on her birthday a reality. Wonderful service, will definitely use it again.”</div><img src="images/Person.png" loading="lazy" width="50" sizes="100vw" srcset="images/Person-p-500.png 500w, images/Person.png 710w" alt="n2xpress - Send money across borders, the easy way." class="testimonial-image">
              <div class="text-block-3">Dayo O.</div>
              <div class="text-block-4">London</div>
            </div>
          </div>
          <div class="slide-2 w-slide">
            <div class="slide-content">
              <div class="text-block-2">&quot;This is a very interesting concept. I wish you plenty of success on this. I’ll definitely use it again.&quot;</div><img src="images/Person.png" loading="lazy" width="50" sizes="100vw" srcset="images/Person-p-500.png 500w, images/Person.png 710w" alt="n2xpress - Send money across borders, the easy way." class="testimonial-image">
              <div class="text-block-3">Femi A.</div>
              <div class="text-block-4">London</div>
            </div>
          </div>
          <div class="slide-3 w-slide">
            <div class="slide-content">
              <div class="text-block-2">&quot;This unique initiative of giving a platform to order for loved ones back home, sure deserves applause.&quot;</div><img src="images/Person.png" loading="lazy" width="50" sizes="100vw" srcset="images/Person-p-500.png 500w, images/Person.png 710w" alt="n2xpress - Send money across borders, the easy way." class="testimonial-image">
              <div class="text-block-3"><strong>Ayodeji Ilayasu</strong></div>
              <div class="text-block-4">Toronto</div>
            </div>
          </div>
          <div class="slide-3 w-slide">
            <div class="slide-content">
              <div class="text-block-2">&quot;I ordered recently for my family in Nigeria. Shout out to N2Xpress for remarkable service delivery.&quot;</div><img src="images/Person.png" loading="lazy" width="50" sizes="100vw" srcset="images/Person-p-500.png 500w, images/Person.png 710w" alt="n2xpress - Send money across borders, the easy way." class="testimonial-image">
              <div class="text-block-3">Kelechi Igboegwu</div>
              <div class="text-block-4">Toronto</div>
            </div>
          </div>
        </div>
        <div class="w-slider-arrow-left"></div>
        <div class="w-slider-arrow-right"></div>
        <div class="slide-nav w-slider-nav w-round"></div>
      </div>
    </div>
  </div>
  <app-home-footer></app-home-footer>